import { render, staticRenderFns } from "./InfoText.vue?vue&type=template&id=1155ed4e&scoped=true&"
import script from "./InfoText.vue?vue&type=script&lang=js&"
export * from "./InfoText.vue?vue&type=script&lang=js&"
import style0 from "./InfoText.vue?vue&type=style&index=0&id=1155ed4e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1155ed4e",
  null
  
)

export default component.exports